import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Link, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { launchSurveys as canLaunchSurveys } from 'modules/engagement/lib/authorization'
import {
  adminClimateImage,
  enpsImage,
  managerClimateImage,
} from 'modules/engagement_insights/assets/Images/index'
import { useEngagementInsightsData } from 'modules/engagement_insights/hooks/useEngagementInsightsData'
import { SelectedSurvey } from 'modules/engagement_insights/lib/widget'

const EmptyPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { moduleAvailabilities, canManageSurveys } = useEngagementContext()
  const canLaunchSurveysValue = canLaunchSurveys(moduleAvailabilities, canManageSurveys)
  const { setSurveyToBeLaunched } = useEngagementInsightsData()

  const adminInsightsTitle = i18n.t('engagement_insights.banner.admin.title')
  const managerInsightsTitle = i18n.t('engagement_insights.banner.manager.title')
  const insightsTitle = canLaunchSurveysValue ? adminInsightsTitle : managerInsightsTitle

  const adminInsightsSubtitle = i18n.t('engagement_insights.banner.admin.subtitle')
  const managerInsightsSubtitle = i18n.t('engagement_insights.banner.manager.subtitle')
  const insightsSubtitle = canLaunchSurveysValue ? adminInsightsSubtitle : managerInsightsSubtitle

  const climateImage = canLaunchSurveysValue ? adminClimateImage : managerClimateImage

  const label = i18n.t('engagement_insights.check_and_launch')
  const HELP_CENTER_URL = 'https://help.factorialhr.com/enps-what-is-that-and-how-can-i-use-it'

  const launchSurveys = () => {
    setSurveyToBeLaunched(SelectedSurvey.Both)
    trackAmplitudeEvents(trackingEvents.engagementInsights.startEngagementSurveys)
    navigate(navigation.engagement.insights.launch.fullPath())
  }

  const ellipseStyle = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderRadius: '50%',
    opacity: '0.2',
  }

  const PurpleEllipse = (
    <Box
      background="champagne800"
      style={{
        ...ellipseStyle,
        bottom: '-10%',
        left: '20%',
        filter: 'blur(97px)',
      }}
    />
  )

  const OrangeEllipse = (
    <Box
      background="radicalRed800"
      style={{
        ...ellipseStyle,
        bottom: '150px',
        left: '300px',
        filter: 'blur(65px)',
      }}
    />
  )

  const trackAmplitudeEvents = (eventName: string) => {
    track(eventName, {
      enps_status: undefined,
      climate_status: undefined,
    })
  }

  const goToHC = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    trackAmplitudeEvents(trackingEvents.engagementInsights.goToHC)
    window.open(HELP_CENTER_URL, '_blank')
  }

  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      padding="s40"
      flexDirection="column"
      alignItems="flexStart"
      justifyContent="spaceBetween"
      style={{
        position: 'relative',
        width: 'max-width',
        height: '223px',
        overflow: 'hidden',
      }}
      background="grey100"
    >
      {PurpleEllipse}
      {OrangeEllipse}
      <Box width="s600" style={{ marginTop: '8px' }}>
        <Text weight="semibold" color="grey1000" size="400">
          {insightsTitle}
        </Text>
      </Box>
      <Box width="s400" style={{ marginBottom: '16px', width: '540px' }}>
        <Text weight="normal" color="grey800" size="200">
          {insightsSubtitle}
        </Text>
      </Box>
      <Box
        flexDirection="row"
        justifyContent="flexEnd"
        style={{ position: 'absolute', top: '24%', right: '0' }}
        paddingTop="s12"
      >
        <img
          src={enpsImage}
          style={{ zIndex: 1, position: 'relative', top: '50%', right: '65%' }}
          alt={i18n.t('app_store_v2.apps.enps.title')}
        />
        <img
          src={climateImage}
          style={{ zIndex: 2, position: 'absolute', bottom: '30%' }}
          alt={i18n.t('surveys.creation.templates.climate.title')}
        />
      </Box>
      <Box
        flexDirection="row"
        justifyContent="spaceAround"
        style={{ width: 'max-width', gap: '24px' }}
        alignItems="center"
      >
        {canLaunchSurveysValue && <Button onClick={() => launchSurveys()}>{label}</Button>}
        <Box style={{ zIndex: '3' }}>
          <Link.Href
            href={HELP_CENTER_URL}
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => goToHC(event)}
          >
            {i18n.t('engagement_insights.banner.learn_more')}
          </Link.Href>
        </Box>
      </Box>
    </Box>
  )
}

export default EmptyPage
